import { Status, BtnText, GlobalBtnStatus, GlobalBtnStatusText, ErrorCode } from "../type";
import { checkDownloadError } from "../BasisComponents/utils";
import { useNavigator } from "@/utils/NetworkCheck";
// 按钮
const cancelBtn = { status: Status.CANCEL, text: BtnText.CANCEL, handleEvent: Status.CANCEL }; // 取消按钮

const retryBtn = { status: Status.RETRY, text: BtnText.RETRY, handleEvent: Status.RETRY }; // 重试按钮

const errorBtn = { status: Status.ERROR, text: BtnText.ERROR, handleEvent: Status.ERROR }; // 失败按钮

const openBtn = { status: Status.SUCCESS, text: BtnText.OPEN, handleEvent: Status.SUCCESS }; // 打开按钮

const cancelBtnAll = {
  status: GlobalBtnStatus.CANCEL_ALL,
  text: GlobalBtnStatusText.CANCEL_ALL,
  handleEvent: GlobalBtnStatus.CANCEL_ALL
}; // 全部取消

const retryBtnAll = {
  status: GlobalBtnStatus.RETRY_ALL,
  text: GlobalBtnStatusText.RETRY_ALL,
  handleEvent: GlobalBtnStatus.RETRY_ALL
}; // 全部重试

const btns = {
  [Status.CANCEL]: cancelBtn,
  [Status.RETRY]: retryBtn,
  [Status.ERROR]: errorBtn,
  [Status.SUCCESS]: openBtn
};

export { btns, cancelBtnAll, retryBtnAll };
